import React from "react";

import { Dialog, Paragraph } from "@fronterahealth/frontera-ui-components";

export type REASONS_TO_BE_OPEN =
  | "MISSING_FILES"
  | "PARSING_FAILED"
  | "FILES_VALIDATING"
  | "REASSESSMENT_MISSING_FILES"
  | "REASSESSMENT_MISSING_PREVIOUS_REPORT";

const reasonsToBeOpenMessageMapping: { [key in REASONS_TO_BE_OPEN]: string } = {
  FILES_VALIDATING:
    "One or more files are currently validating, please wait for them to finish validation before continuing. This may take several minutes.",
  PARSING_FAILED: "Failed to parse certain files. Please remove the incorrect files and upload new ones.",
  MISSING_FILES: "Please upload required assessments in order to continue with report generation.",
  REASSESSMENT_MISSING_FILES: [
    "To suggest meaningful goals with AI, we need just a bit more information. Try adding one of the following:",
    "",
    "• A curriculum-based assessment:",
    "\t  • VB-MAPP",
    "\t  • ABLLS-R",
    "\t  • AFLS",
    "\t  • PEAK",
    "\t  • ESDM",
    "\t  • Essential For Living Quick",
    "\t  • Skill Streaming",
    "\t  • Socially Savvy",
    "",
    '• Notes in the "Opportunities for New Goals" section',
  ].join("\n"),
  REASSESSMENT_MISSING_PREVIOUS_REPORT:
    "Please upload a previous assessment report before generating the reassessment report.",
};

interface ValidationNoticeDialogProps {
  reasonToBeOpen: REASONS_TO_BE_OPEN | null;
  closeDialog: () => void;
}

export const ValidationNoticeDialog: React.FC<ValidationNoticeDialogProps> = ({ reasonToBeOpen, closeDialog }) => {
  return (
    <Dialog
      size="lg"
      open={!!reasonToBeOpen}
      setOpen={() => closeDialog()}
      title="Notice"
      primaryButton={{
        text: "Close",
        onClick: async () => closeDialog(),
      }}
      secondaryButton={undefined}
    >
      {reasonToBeOpen ? (
        <Paragraph displayType="normal" colorType="secondary" style={{ whiteSpace: "pre-wrap" }}>
          {reasonsToBeOpenMessageMapping[reasonToBeOpen]}
        </Paragraph>
      ) : null}
    </Dialog>
  );
};
